import privacypolicyCss from './privacypolicy.module.css';
import Banner from '../img/pri/Privacy-Policy.webp';
import AlbumIcon from '@mui/icons-material/Album';

import { Container, Row } from 'react-bootstrap';


function privacy() {

  return (
    <div className={privacypolicyCss.privacypolicyBG}>
        <img className={privacypolicyCss.banner} src={Banner}/>

      <div className={privacypolicyCss.bgText}>
            <Container>
              <div className={privacypolicyCss.mainContainer}>

                  <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyText}>
                     Our Learning Management System (LMS) is committed to protecting your privacy. We collect only school information for generate school principal user credentials to provide educational content, track learning progress, and deliver assessments. This may include your name, email, and usage data. Your data is stored securely and used solely to enhance your learning experience. We do not share your information with third parties without your consent, except as required by law.
                  </div>
                </div>


                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>B2B Service Model</div>
                  <div className={privacypolicyCss.policyText}>
                      Our LMS operates strictly under a Business-to-Business (B2B) model. We do not provide services directly to students or parents. Instead, we license our LMS platform to Schools, who manage and control access for their students and educators.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>No Direct Data Collection from Children or Parents</div>
                  <div className={privacypolicyCss.policyText}>
                      We do not request, collect, or store any personal information directly from students or their parents or guardians. All student-related data is entered and managed solely by the authorized School administrators.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Data Ownership and Control</div>
                  <div className={privacypolicyCss.policyText}>
                        All student data entered into the LMS is fully owned and controlled by the School. Schools are responsible for:
                        <ul>
                          <li>Managing student registrations and account information</li>
                          <li>Ensuring data accuracy and compliance with local regulations</li>
                          <li>Deleting student records when no longer needed</li>
                        </ul>
                        Schools can delete any or all of their data at any time using the provided administrative tools or by contacting our support team.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Content Policy</div>
                  <div className={privacypolicyCss.policyText}>
                         Our LMS platform hosts only educational content suitable for Kindergarten to 8th Grade students. We do not permit the upload, distribution, or display of any non-educational, harmful, or inappropriate material. All content on the portal is curriculum-aligned and designed for academic learning.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Data Security</div>
                  <div className={privacypolicyCss.policyText}>
                  We implement industry-standard security measures to protect data stored on our platform. These include encryption, access controls, and secure data centers. However, the School remains responsible for setting and maintaining appropriate access permissions for its users. 
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Compliance with Laws</div>
                  <div className={privacypolicyCss.policyText}>
                  We are committed to supporting our School partners in complying with all relevant data privacy laws and regulations, including child data protection rules. As we do not collect data from children directly, our LMS facilitates compliance through data minimization and strict access controls.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Data Retention and Deletion</div>
                  <div className={privacypolicyCss.policyText}>
                  All data is retained only as long as necessary for the School's use of our services. Upon termination of service or upon request by the School, all data can be permanently deleted from our systems.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Changes to This Policy</div>
                  <div className={privacypolicyCss.policyText}>
                          We may update this Privacy Policy from time to time. When we do, we will notify our School partners of any significant changes. The updated policy will always be available on our website with the effective date clearly indicated.
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyHead}>Contact Information</div>
                  <div className={privacypolicyCss.policyText}>
                          If you have any questions about this Privacy Policy or our data practices, please contact us at:
                  </div>
                  <div className={privacypolicyCss.policyText}>
                         Email : info@swaadhyayan.com
                  </div>
                  <div className={privacypolicyCss.policyText}>
                        Address : 4583/15, Opp. L.I.C. Building, Daryaganj, New Delhi – 110002, INDIA
                  </div>
                  <div className={privacypolicyCss.policyText}>
                        Contact No. : +91-11-43585858
                  </div>
                </div>

                <div className={privacypolicyCss.texSection}>
                  <div className={privacypolicyCss.policyText}>
                          Thank you for trusting our LMS platform to support your school's educational needs.
                  </div>
                </div>
              </div>


            </Container>
          </div>
   </div>
  );
}
export default privacy;
